import { InjectionToken } from '@angular/core';

export interface DateRangeSelectionMaxLengthOwner<D = unknown> {
  maxLengthInDays: number | undefined;
  maxLengthInYears: number | undefined;
  writeTemporaryMinMaxValues(minDate?: D, maxDate?: D): void;
}

/** Injection token used to mark an object that has a maxLengthInDays or maxLengthInYears readable property */
export const DATE_RANGE_SELECTION_MAX_LENGTH_OWNER = new InjectionToken<DateRangeSelectionMaxLengthOwner>(
  'DATE_RANGE_SELECTION_MAX_LENGTH_OWNER'
);
